// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1860ada9","613":"cbc6732c","664":"d8817565","724":"506054ac"}[chunkId] + ".chunk.js";
};